import { useState } from 'react'
import { Image } from 'theme-ui'
import { keyframes } from '@emotion/react'

export default function FadeInImage({ src, ...rest }) {
    const [isLoaded, setIsLoaded] = useState(false)
    const fadeIn = keyframes({ from: { opacity: 0 }, to: { opacity: 1 } })

    return (
        <Image
            sx={{
                width: '100%',
                height: 'auto',
                opacity: isLoaded ? 1 : 0,
                animation: `${isLoaded && fadeIn} 0.5s linear`,
                ...rest,
            }}
            onLoad={() => setIsLoaded(true)}
            loading="lazy"
            src={src}
            srcSet={`${src} 1x, ${src} 2x`}
        />
    )
}
